/*
    Do not forget, when applying discounts using percentages, 
    the rule is to use the largest percentage, it is not cumulative. 
    That is, if we have a 5% discount but we also have another discount of 10%, 
    then the final discount is 10%, not 15%.

*/
/*
  Bundle rule:
  If CHC33021 + CHC43015 are both selected, total tuition must be $10,000.
  Standalone total is typically $12,000 (5,000 + 7,000), so discount = 2,000.
*/
export function asianAllOthersCountriesDiscountsAgedCare(
  data,
  paymentType,
  courses,
  specialCases
) {
  // Reset defaults
  for (const course of courses) {
    course.finalTuition = course?.tuition;
    course.discountsApplied = [];
  }

  const CODE_1 = "CHC33021";
  const CODE_2 = "CHC43015";
  const TARGET_TOTAL = 10000;

  const c1 = courses.find((c) => c?.coursePricing?.course?.course_code === CODE_1);
  const c2 = courses.find((c) => c?.coursePricing?.course?.course_code === CODE_2);

  if (c1 && c2) {
    const currentTotal = (Number(c1.finalTuition) || 0) + (Number(c2.finalTuition) || 0);
    const discount = currentTotal - TARGET_TOTAL;

    if (discount > 0) {
      // Apply discount to CHC43015 by preference
      const target = c2 || c1;
      target.finalTuition = Math.max(0, (Number(target.finalTuition) || 0) - discount);
      target.discountsApplied.push({
        code: "bundle_chc33021_chc43015",
        description: "Bundle price for CHC33021 + CHC43015 (Total $10,000)",
        amount: discount,
      });

      console.debug(
        `[ALS_COLLEGE aged_care] Bundle discount applied: -$${discount} to ${target?.coursePricing?.course?.course_code}`
      );
    }
  }

  console.debug("Courses after discounts were applied:", courses);
}

